import { User, Account } from '@cliengo/mfe-utils/types';
import OneSignal from 'react-onesignal';

import config from '@/config/environment';

export async function runOneSignal(user: User, account: Account) {
  try {
    await OneSignal.init({
      appId: config.ONESIGNAL_APP_ID,
      allowLocalhostAsSecureOrigin: true,
      serviceWorkerParam: {
        scope: '/js/push/onesignal/',
      },
      serviceWorkerPath: './js/push/onesignal/OneSignalSDKWorker.js',
      serviceWorkerUpdaterPath: './js/push/onesignal/OneSignalSDKWorker.js',
    });
    await OneSignal.Slidedown.promptPush();
    await OneSignal.login(user.id);
    OneSignal.User.addTags({
      userId: user.id,
      companyId: user.companyId || account.id,
    });
    console.info('OneSignal initialized');
  } catch (error) {
    console.error('Cannot start OneSignal', error);
  }
}
